import React, { useState } from 'react';

/*
 * EU harmonised notice on the legal guarantee of conformity, at checkout — before the
 * order is placed. Mandatory from 2026-09-27 (Directive (EU) 2024/825, design fixed by
 * Implementing Regulation (EU) 2025/1960). The storefront copy and the rules for the
 * file live in wp-content/mu-plugins/91-legal-guarantee-notice.php — keep the label,
 * the image path and the link in step with it.
 *
 * The image is the Commission's own file, shown whole and unmodified (no recolour, no
 * crop, no re-encode). It is rendered only once the modal is opened, so the checkout
 * pays nothing for it until someone asks.
 */
const LABEL = 'Τα δικαιώματά σας από τη νόμιμη εγγύηση';
const IMG = '/wp-content/themes/metro-child/assets/legal-guarantee/nomimi-eggyisi-el.png';
const URL = 'https://europa.eu/youreurope/%CE%B5%CE%B3%CE%B3%CF%85%CE%AE%CF%83%CE%B5%CE%B9%CF%82';

export default function LegalGuarantee() {
  const [open, setOpen] = useState(false);

  return (
    <div className="cn-lg">
      <button type="button" className="cn-linkbtn cn-lg__btn" onClick={() => setOpen(true)}>{LABEL}</button>
      {open && (
        <div className="cn-terms-modal" role="dialog" aria-modal="true" aria-label={LABEL} onClick={() => setOpen(false)}>
          <div className="cn-terms-modal__box" onClick={(e) => e.stopPropagation()}>
            <div className="cn-terms-modal__head">
              <span className="cn-terms-modal__title">Νόμιμη εγγύηση</span>
              <button type="button" className="cn-terms-modal__close" aria-label="Κλείσιμο" onClick={() => setOpen(false)}>✕</button>
            </div>
            <div className="cn-terms-modal__body cn-lg__body">
              <a href={IMG} target="_blank" rel="noopener noreferrer">
                <img
                  className="cn-lg__img"
                  src={IMG}
                  width="1654"
                  height="2339"
                  alt="Νόμιμη εγγύηση: ελάχιστη νόμιμη εγγύηση δύο ετών για τα αγαθά που πωλούνται στην Ευρωπαϊκή Ένωση"
                />
              </a>
              <p>
                Περισσότερα για τα δικαιώματά σας:{' '}
                <a href={URL} target="_blank" rel="noopener noreferrer">europa.eu/youreurope/εγγυήσεις</a>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
